/**
 * Locale do Easy Email (chaves = inglês original do `t("...")`).
 * Passar em EmailEditorProvider `locale={...}`.
 */
export type EasyEmailLocaleMap = Record<string, string>;

const sharedCore: EasyEmailLocaleMap = {
  undo: "Desfazer",
  redo: "Refazer",
  Configuration: "Configuração",
  "Source code": "Código-fonte",
  Block: "Blocos",
  Layer: "Camadas",
  Content: "Conteúdo",
  Layout: "Layout",
  attributes: "atributos",
  Page: "Página",
  Text: "Texto",
  Image: "Imagem",
  Button: "Botão",
  Hero: "Destaque",
  Spacer: "Espaço",
  Divider: "Divisor",
  Social: "Redes sociais",
  Wrapper: "Agrupador",
  Section: "Seção",
  Column: "Coluna",
  Group: "Grupo",
  Table: "Tabela",
  Navbar: "Menu",
  Accordion: "Acordeão",
  Carousel: "Carrossel",
  "Email Setting": "Configuração do e-mail",
  "Theme Setting": "Tema do e-mail",
  Subject: "Assunto",
  SubTitle: "Subtítulo",
  Width: "Largura",
  Height: "Altura",
  Breakpoint: "Ponto de quebra",
  "Allows you to control on which breakpoint the layout should go desktop/mobile.":
    "Define a partir de qual largura o layout muda entre desktop e celular.",
  "Font family": "Fonte",
  "Font size": "Tamanho da fonte",
  "Font size (px)": "Tamanho da fonte (px)",
  "Font weight": "Peso da fonte",
  "Line height": "Altura da linha",
  "Letter spacing": "Espaçamento entre letras",
  "Text color": "Cor do texto",
  Background: "Fundo",
  "Background color": "Cor de fundo",
  "Content background": "Fundo do conteúdo",
  "Container background color": "Fundo do container",
  "User style": "CSS personalizado",
  "Import font": "Importar fonte",
  "Points to a hosted css file": "URL de um arquivo CSS hospedado",
  Padding: "Margem interna",
  Margin: "Margem",
  Border: "Borda",
  "Border radius": "Arredondamento",
  Align: "Alinhamento",
  "Text align": "Alinhamento do texto",
  "Vertical align": "Alinhamento vertical",
  Dimension: "Dimensão",
  Typography: "Tipografia",
  Decoration: "Decoração",
  Setting: "Configuração",
  Color: "Cor",
  Style: "Estilo",
  Mode: "Modo",
  Url: "URL",
  Link: "Link",
  Apply: "Aplicar",
  Save: "Salvar",
  Edit: "Editar",
  Preview: "Visualizar",
  Remove: "Remover",
  Delete: "Excluir",
  Copy: "Copiar",
  "Move up": "Mover para cima",
  "Move down": "Mover para baixo",
  "Insert before": "Inserir antes",
  "Insert after": "Inserir depois",
  "Drag here": "Arraste aqui",
  "Select parent block": "Selecionar bloco pai",
  "No matching components": "Nenhum componente correspondente",
  "Uploading...": "Enviando…",
  "Upload failed": "Falha no envio",
  "Please select": "Selecione",
  None: "Nenhum",
  Left: "Esquerda",
  Right: "Direita",
  Center: "Centro",
  Top: "Topo",
  Bottom: "Base",
  left: "esquerda",
  center: "centro",
  right: "direita",
  top: "topo",
  middle: "meio",
  bottom: "base",
  Bold: "Negrito",
  Italic: "Itálico",
  Underline: "Sublinhado",
  Strikethrough: "Tachado",
  "Align left": "Alinhar à esquerda",
  "Align center": "Centralizar",
  "Align right": "Alinhar à direita",
  "Merge tag": "Tag de personalização",
  "Editor Loading...": "Carregando editor…",
  "2 columns": "2 colunas",
  "3 columns": "3 colunas",
  "4 columns": "4 colunas",
  True: "Sim",
  False: "Não",
  Html: "HTML",
  "Html mode": "Modo HTML",
  Name: "Nome",
  Title: "Título",
  Description: "Descrição",
  Opacity: "Opacidade",
  Direction: "Direção",
  Condition: "Condição",
  And: "E",
  Or: "Ou",
};

/** Português (Brasil) — padrão do painel. */
export const easyEmailLocalePtBr: EasyEmailLocaleMap = { ...sharedCore };

/** Inglês (UI do editor quando o painel está em en). */
export const easyEmailLocaleEn: EasyEmailLocaleMap = {
  undo: "Undo",
  redo: "Redo",
  // chaves = valores: identity (fallback do próprio Easy Email)
};

/** Espanhol. */
export const easyEmailLocaleEs: EasyEmailLocaleMap = {
  ...sharedCore,
  undo: "Deshacer",
  redo: "Rehacer",
  Configuration: "Configuración",
  "Source code": "Código fuente",
  Block: "Bloques",
  Layer: "Capas",
  Content: "Contenido",
  attributes: "atributos",
  Page: "Página",
  Text: "Texto",
  Image: "Imagen",
  Button: "Botón",
  Hero: "Destacado",
  Spacer: "Espacio",
  Divider: "Divisor",
  Social: "Redes sociales",
  Wrapper: "Agrupador",
  Section: "Sección",
  Column: "Columna",
  Group: "Grupo",
  "Email Setting": "Configuración del correo",
  "Theme Setting": "Tema del correo",
  Subject: "Asunto",
  SubTitle: "Subtítulo",
  Width: "Ancho",
  Height: "Alto",
  Breakpoint: "Punto de quiebre",
  "Allows you to control on which breakpoint the layout should go desktop/mobile.":
    "Define a partir de qué ancho el diseño cambia entre escritorio y móvil.",
  "Font family": "Fuente",
  "Font size": "Tamaño de fuente",
  "Font size (px)": "Tamaño de fuente (px)",
  "Font weight": "Peso de la fuente",
  "Line height": "Altura de línea",
  "Text color": "Color del texto",
  Background: "Fondo",
  "Background color": "Color de fondo",
  "Content background": "Fondo del contenido",
  "User style": "CSS personalizado",
  Padding: "Relleno",
  Border: "Borde",
  "Border radius": "Redondeo",
  Align: "Alineación",
  "Text align": "Alineación del texto",
  Delete: "Eliminar",
  Copy: "Copiar",
  Preview: "Vista previa",
  Remove: "Quitar",
  Save: "Guardar",
  Edit: "Editar",
  Apply: "Aplicar",
  "No matching components": "Ningún componente coincidente",
  "Uploading...": "Subiendo…",
  "Upload failed": "Error al subir",
  "Editor Loading...": "Cargando editor…",
  "2 columns": "2 columnas",
  "3 columns": "3 columnas",
  "4 columns": "4 columnas",
};

export const resolveEasyEmailLocale = (
  language: string
): EasyEmailLocaleMap => {
  const lang = (language || "pt-BR").toLowerCase();
  if (lang.startsWith("es")) {
    return easyEmailLocaleEs;
  }
  if (lang.startsWith("en")) {
    return easyEmailLocaleEn;
  }
  return easyEmailLocalePtBr;
};
